import LayersSvg from '@assets/images/svg/layers.svg';
import React from 'react';
import { View } from 'react-native';

export interface LayersIconProps {
  size?: number;
  color?: string;
}

/** Stacked layers icon (Figma "Number of Units" row icon). */
export function LayersIcon({ size = 24, color = '#333333' }: Readonly<LayersIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LayersSvg width={size} height={size} color={color} />
    </View>
  );
}

export default LayersIcon;
